import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent } from '@material-ui/core';
import styles from './styles.module.css';

const CustomModal = ({ isOpen, handleClose, children, style, maxWidth = 'md' }) => (
  <Dialog open={isOpen} onClose={handleClose} maxWidth={maxWidth}>
    <DialogContent className={styles.container} style={{ ...style, borderRadius: 0 }}>
      {children}
    </DialogContent>
  </Dialog>
);

CustomModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default CustomModal;
